import type { AdPlacement } from '../types';

export const AD_PLACEMENTS = {
  HOME_BANNER: 'home_banner',
  NEWAUTHORS_BANNER: 'newauthors_banner',
  ARTICLES_BANNER: 'articles_banner',
} as const satisfies Record<string, AdPlacement>;

export const ADS_SESSION_STORAGE_KEY = 'molwe_ads_session';
export const ARTICLE_BANNER_SCROLL_PX = 150;

export const PROMO_BANNER_MAX_WIDTH = 605;
export const PROMO_BANNER_MAX_HEIGHT = 300;
